// @mui
import { PickersShortcutsItem } from '@mui/x-date-pickers/PickersShortcuts';
import { DateRange } from '@mui/x-date-pickers-pro/models';
// luxon
import { DateTime } from 'luxon';

export const shortcutItems: PickersShortcutsItem<DateRange<DateTime>>[] = [
  {
    label: 'This Week',
    getValue: () => {
      const today = DateTime.now();
      return [today.startOf('week'), today.endOf('week')];
    },
  },
  {
    label: 'Last Month',
    getValue: () => {
      const today = DateTime.now();
      const startOfLastMonth = today.plus({ months: -1 }).startOf('month');
      return [startOfLastMonth, startOfLastMonth.endOf('month')];
    },
  },
  {
    label: 'YTD',
    getValue: () => {
      const today = DateTime.now();
      const startOfYear = today.startOf('year');
      return [startOfYear, today];
    },
  },
  {
    label: 'Reset',
    getValue: () => {
      const today = DateTime.now();
      return [today.startOf('month'), today.endOf('month')];
    },
  },
];
